var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.TShirtsData),function(TShirt,index){return _c('ListItem',{key:TShirt.id,class:{
    'border-bottom': true,
    'border-top': index === 0},attrs:{"tshirt-id":TShirt.id,"brand-logo":TShirt.brandLogo,"brand-name":TShirt.brandName,"product-name":TShirt.name}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }